import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from "react-router"
import { Dropdown } from 'react-bootstrap'

import DeleteModal from 'pages/parts/DeleteModal'

import { httpOk, GET, DELETE } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalDelete, setModalDelete] = useState(false)

	async function searchWithFilter() {
		var filterUrl = "/external-integrations"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	function toggleModalDelete(bool = false, item = {}) {
		setSelectedItem(item)
		setModalDelete(bool)
	}

	async function deleteItem() {
		const response = await DELETE(`/external-integrations/${selectedItem.id}`, {}, { loader: true })

		if (httpOk(response)) {
			toggleModalDelete()
			searchWithFilter()
		}
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('integrations')} [{data.length}]
				</h4>
				<div className="d-flex">
					<Link className="btn-rounded btn btn-primary" to="/external-integrations/create">
						{t('create')}
					</Link>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '20%' }}>{t('type')}</th>
									<th style={{ 'width': '60%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>
											<Link className="text-primary cursor table-first-column-clickable"
												to={`/external-integrations/update/${item.id}`}>
												{item.name}
											</Link>
										</td>
										<td>{item.integration_type_name}</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Link className="table-dropdown-item"
															to={`/external-integrations/update/${item.id}`}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</Link>
														<div className="table-dropdown-item text-danger"
															onClick={() => toggleModalDelete(true, item)}>
															<i className="uil-times"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<DeleteModal modalDelete={modalDelete} setModalDelete={setModalDelete} deleteItem={deleteItem} />
		</>
	)
}

export default Index